import Vue from 'vue'
import './plugins/storage'
import './plugins/vuetify'
import './plugins/axios'
import './plugins/filters'
import config from './config'
import router from './plugins/router'
import store from './plugins/store'
import './plugins/rights'
import App from './App.vue'
import Err from './Err.vue'

Vue.config.productionTip = false

config.mount(Vue.prototype, store)
    .then(() => {
        new Vue({
            store,
            router,
            render: h => h(App)
        }).$mount('#app')
    })
    .catch((err) => {
        Vue.prototype.currentError = err
        new Vue({
            render: h => h(Err)
        }).$mount('#app')
    })
